<template>
  <div>
    <ValidationObserver ref="observer" tag="div" class="container">
      <EmptyCart v-if="cart_count == 0" />
      <div v-else class="row">
        <div class="col-12 col-md-5">
          <cart-order-summary />
        </div>
        <div class="col-12 col-md-7 order-md-first order-last">
          <div class="slide-alert" v-if="!requires.payment">
            <div class="well" v-html="requires.customer_info_message"></div>
          </div>
          <customer />
          <!-- /.End of customer info -->
          <shipping
            v-if="requires.shipping_location || requires.shipping_request"
          />
          <!-- /.End of shipping info -->
          <payment />

          <div v-if="error_count > 0" class="alert alert-danger" role="alert">
            <fa-icon :icon="['far', 'times']" />
            <span v-for="(value, field) in errors" :key="field" class="item">
              <span>&nbsp;{{ value }}</span
              >.
            </span>
          </div>

          <div class="content-footer">
            <button
              type="button"
              class="btn btn-primary btn-block"
              @click="beginCheckout"
              :disabled="checkoutInFlight"
            >
              {{ requires.submit_order_label }}
            </button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventBus from "@/event-bus";

import { v4 as uuidv4 } from "uuid";

import CartOrderSummary from "@/components/cart/OrderSummary.vue";
import Customer from "@/components/cart/Customer";
import EmptyCart from "@/components/cart/EmptyCart";
import Shipping from "@/components/cart/Shipping";
import Payment from "@/components/cart/Payment";
import { Stripe } from "@/components/stripe/stripeElements";

export default {
  components: {
    CartOrderSummary,
    Customer,
    EmptyCart,
    Shipping,
    Payment,
  },
  data() {
    return {
      coupon: null,
      confirm: false,
      checkoutInFlight: false,
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.errors,
      error_count: (state) => Object.keys(state.errors).length,
      cart: (state) => state.cart || {},
      customer: (state) => state.customer || {},
      currency: (state) => state.currency,
      cart_count: (state) => state.cart.items.length,
      continue_shopping_url: (state) => state.continue_shopping_url,
      requires: (state) => state.requires || {},
      card: "card",
      gateway: (state) => state.payment.gateway,
    }),
  },
  mounted() {
    EventBus.$on(
      "cardinal-payments-validated",
      this.onCardinalPaymentsValidated
    );

    EventBus.$on("stripe-express-checkout-confirm", this.stripeConnectCheckout);
    EventBus.$on("paypal-standard-checkout", this.paypalStandardCheckout);
  },
  destroyed() {
    EventBus.$off(
      "cardinal-payments-validated",
      this.onCardinalPaymentsValidated
    );

    EventBus.$off("stripe-express-checkout-confirm");
    EventBus.$off("paypal-standard-checkout");
  },
  methods: {
    async onCardinalPaymentsValidated(event) {
      this.$store.commit("setGateway", "creditcard");
      console.log("on cardinal payment!");
      console.log(event);

      let { data, jwt } = event;
      let loader = null;
      let ok = false;

      switch (data.ActionCode) {
        case "SUCCESS":
          // SUCCESS Handle successful transaction, send JWT to backend to verify
          this.$store.commit("setCardToken", jwt);
          loader = this.$loading.show();
          try {
            await this.$store.dispatch("purchase");
          } finally {
            loader.hide();
          }
          break;

        case "NOACTION":
          // NOACTION Handle no actionable outcome
          if (data.ErrorNumber === 0) {
            if (
              data.Payment.ExtendedData.Enrolled === "U" ||
              data.Payment.ExtendedData.Enrolled === "B"
            ) {
              // not enrolled (U), or bypassed by rules (B) allow
              ok = true;
            } else if (
              // enrolled and signature is valid, allow
              data.Payment.ExtendedData.SignatureVerification === "Y"
            ) {
              ok = true;
            }
          }
          if (ok) {
            console.log("NOACTION continue");
            this.$store.commit("setCardToken", jwt);
            loader = this.$loading.show();
            await this.$store.dispatch("purchase");
            loader.hide();
          } else {
            console.log("NOACTION fail");
            alert(this.$t("payment.cardinal_failure"));
          }
          break;

        case "FAILURE":
          // Handle failed transaction attempt
          alert(this.$t("payment.cardinal_failure"));
          break;

        case "ERROR":
          // Handle service level error
          alert(data.ErrorDescription);
          break;
      }
    },
    applyCoupon() {
      if (this.coupon) {
        this.$store
          .dispatch("applyCoupon", this.coupon)
          .then(() => (this.coupon = null));
      }
    },
    async paypalCardinalCommerceCheckout() {
      const Cardinal = window.Cardinal;

      let exp_year = parseInt(this.card.exp.year);
      if (exp_year < 2000) {
        exp_year += 2000;
      }

      let data = {
        OrderDetails: {
          OrderNumber: uuidv4(),
          Amount: parseInt(this.cart.total * 100.0),
          CurrencyCode: this.$store.state.currency,
          OrderChannel: "S",
        },
        Consumer: {
          Account: {
            AccountNumber: this.card.card_number.replace(/ /g, ""),
            ExpirationMonth: parseInt(this.card.exp.month),
            ExpirationYear: exp_year,
            CardCode: this.card.cvv2,
          },
        },
      };

      console.dir(data);

      Cardinal.start("cca", data);

      //this.$store.commit("setCardToken", paymentMethod.id);
      //let loader = this.$loading.show();
      //await this.$store.dispatch("purchase");
      //loader.hide();
    },
    async stripeConnectCheckout() {
      this.$store.commit("setGateway", "creditcard");

      const isValid = await this.doValidate();

      if (!isValid) {
        return;
      }

      console.log(this.$stripe);
      const { error: submitError } = await window.$stripe.elements.submit();
      if (submitError) {
        // handleError(submitError);
        window.alert(submitError.message);
        console.log(submitError);
        return;
      }

      const result = await window.$stripe.stripe.createPaymentMethod({
        elements: window.$stripe.elements,
        params: {
          billing_details: {
            address: {
              city: this.$store.state.billing.location.city,
              country: this.$store.state.billing.location.country_code,
              line1: this.$store.state.billing.location.address1,
              line2: this.$store.state.billing.location.address2,
              postal_code: this.$store.state.billing.location.postal_code,
              state: this.$store.state.billing.location.province,
            },
            email: this.$store.state.customer.email,
            name:
              this.$store.state.customer.first_name +
              " " +
              this.$store.state.customer.last_name,
            phone: null,
          },
        },
      });
      if (result.error) {
        window.alert(result.error.message);
        console.log(result.error);
      } else {
        console.log(result);
        this.$store.commit("setCardToken", result.paymentMethod.id);
        let loader = this.$loading.show();
        try {
          await this.$store.dispatch("purchase");
        } finally {
          loader.hide();
        }
      }
    },
    async stripeCheckout() {
      this.$store.commit("setGateway", "creditcard");
      const isValid = await this.doValidate();

      if (!isValid) {
        return;
      }

      const { paymentMethod, error } = await Stripe.createPaymentMethod(
        "card",
        {
          billing_details: {
            address: {
              city: this.$store.state.billing.location.city,
              country: this.$store.state.billing.location.country_code,
              line1: this.$store.state.billing.location.address1,
              line2: this.$store.state.billing.location.address2,
              postal_code: this.$store.state.billing.location.postal_code,
              state: this.$store.state.billing.location.province,
            },
            email: null,
            name:
              this.$store.state.customer.first_name +
              " " +
              this.$store.state.customer.last_name,
            phone: null,
          },
        }
      );
      if (error) {
        window.alert(error.message);
        console.log(error);
      } else {
        this.$store.commit("setCardToken", paymentMethod.id);
        let loader = this.$loading.show();
        try {
          await this.$store.dispatch("purchase");
        } finally {
          loader.hide();
        }
      }
    },
    async paypalStandardCheckout() {
      console.log("paypal checkout");

      this.checkout("paypal");
    },
    async beginCheckout() {
      // force creditcard mode if the total > 0
      if (this.cart.total > 0) {
        console.log("creditcard checkout");

        if (this.$store.state.payment.methods.length == 1) {
          // grab the only type available
          this.checkout(this.$store.state.payment.methods[0].gateway);
        } else {
          this.checkout("creditcard");
        }
      } else {
        console.log("free checkout");

        this.checkout("free");
      }
    },
    async getRecaptchaToken() {
      return new Promise((resolve) => {
        if (!window.grecaptcha) {
          return resolve(null);
        }

        window.grecaptcha.ready(
          () =>
            void (async () => {
              const token = await window.grecaptcha.execute(
                "6LdXFtgpAAAAANEhUbuifXieVpystf85Iskkv232",
                { action: "submit" }
              );

              resolve(token);
            })()
        );
      });
    },
    async doValidate() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        return true;
      } else {
        document
          .querySelector(
            "input.is-invalid,select.is-invalid,textarea.is-invalid"
          )
          .focus();
        return false;
      }
    },
    async checkout(gateway = null) {
      if (gateway !== null) {
        console.log("checking out with gateway " + gateway + "...");
        this.$store.commit("setGateway", gateway);
      }
      console.log("begin checkout");
      const isValid = await this.doValidate();

      if (isValid) {
        this.checkoutInFlight = true;

        try {
          this.$store.commit(
            "setRecaptchaToken",
            await this.getRecaptchaToken()
          );

          // grab the current payment method
          const method = this.$store.state.payment.methods.find(
            (method) => method.gateway == this.$store.state.payment.gateway
          );

          if (method?.client_side_gateway?.name == "StripeJsGateway") {
            await this.stripeCheckout();
          } else if (
            method?.client_side_gateway?.name == "StripeConnectGateway"
          ) {
            await this.stripeConnectCheckout(method);
          } else if (method?.client_side_gateway?.name == "PayPalProGateway") {
            await this.paypalCardinalCommerceCheckout();
          } else {
            let loader = this.$loading.show();
            // assume it is handled server side based on the current state
            try {
              await this.$store.dispatch("purchase");
            } finally {
              loader.hide();
            }
          }
        } finally {
          this.checkoutInFlight = false;
        }
      }
    },
  },
};
</script>
